import { FaMapMarkerAlt } from "react-icons/fa";

const LocationBadge = ({ children }) => {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs text-slate-600 dark:border-white/10 dark:bg-white/5 dark:text-slate-300">
      <FaMapMarkerAlt size={10} className="text-sky-500" />
      {children}
    </span>
  );
};

export default LocationBadge;
